import { V3Button } from "../../../components/Button";
import { V3IconFacebook, V3IconLinkedin, V3IconTwitter } from "../../../components/Icons";
import { InlineLink } from "../../../components/ReusableStyledComponents/InlineLink";
import { V3BodyGrey35 } from "../../../components/ReusableStyledComponents/V3BodyGrey35";
import { V3ContentLargeWrapper } from "../../../components/ReusableStyledComponents/V3ContentLargeWrapper";
import { V3TextInput } from "../../../components/TextInput/V3TextInput";
import { V3Body, V3Title } from "../../../components/Typography";
import { V3SettingsLinksPanel } from "../../../components/V3LinksPanel";
import { VerticalSpacing } from "../../../components/VerticalSpacing";
import { SidebarLayout } from "../../../layout/SideBarLayout";
import { AuthenticatedUser } from "../../../types/user";
import { copyTextToClipboard } from "../../../utils/copyToClipboard";
import {
    RefDashboardBottomPanel,
    RefDashboardBottomPanelCard,
    RefDashboarPanel,
    RefDashTopPanel,
    ReferralMaxWidth,
    RefSocialWrapper,
    V3RefDashboard
} from "./V3ReferralPageLayout.styles";
import { V3SimpleNavbar } from "../../../components/V3SimpleNavbar";
import { FAQPrivateArea } from "../../../components/FAQPrivateArea";

interface V3ReferralPageLayoutProps {
    user: AuthenticatedUser;
}

export const V3ReferralPageLayout = ({ user }: V3ReferralPageLayoutProps) => {
    const inviteUrl = `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${user?.slug}/invite?key=${user?.referralKey}`;
    const encodedInviteUrl = encodeURIComponent(inviteUrl);

    return (
        <SidebarLayout
            disableFadeIn
            title="Refer a Friend"
            leftPanel={<V3SettingsLinksPanel />}
            topNavBarContent={<V3SimpleNavbar title="Settings" />}
            rightPanel={
                <V3ContentLargeWrapper>
                    <V3SimpleNavbar title="Refer a friend" withTitle />
                    <V3RefDashboard>
                        <VerticalSpacing bottom={8}>
                            <V3Title>Get $30 for every friend who joins Authory</V3Title>
                        </VerticalSpacing>
                        <VerticalSpacing bottom={37}>
                            <ReferralMaxWidth>
                                <V3Body>
                                    Invite your friends and colleagues to join Authory. <strong>It's a win-win:</strong> They’ll get 30 days free
                                    trial instead of the standard 14 days, and you'll receive USD 30 for everyone who sticks with Authory after the
                                    free trial.
                                </V3Body>
                            </ReferralMaxWidth>
                        </VerticalSpacing>
                    </V3RefDashboard>
                    <RefDashboarPanel>
                        <RefDashTopPanel>
                            <div>
                                <V3TextInput label="Ready to spread the word? Here is your personal invite link: " value={inviteUrl} />
                            </div>
                            <div>
                                <V3Button
                                    color="secondary"
                                    text="Copy Link"
                                    minWidth={140}
                                    onClick={() => {
                                        copyTextToClipboard(inviteUrl);
                                    }}
                                />
                            </div>
                        </RefDashTopPanel>
                        <RefDashboardBottomPanel>
                            <RefDashboardBottomPanelCard>
                                <RefSocialWrapper>
                                    <div>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="24" height="24" rx="4" fill="#F4F4F6" />
                                            <path
                                                d="M16.6667 7.33398H7.33333C6.59695 7.33398 6 7.93094 6 8.66732V15.334C6 16.0704 6.59695 16.6673 7.33333 16.6673H16.6667C17.403 16.6673 18 16.0704 18 15.334V8.66732C18 7.93094 17.403 7.33398 16.6667 7.33398Z"
                                                stroke="#2E77FF"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M6 8.66602L12 12.666L18 8.66602"
                                                stroke="#2E77FF"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    <div>
                                        <V3Body>Share via email</V3Body>
                                    </div>
                                </RefSocialWrapper>
                            </RefDashboardBottomPanelCard>
                            <RefDashboardBottomPanelCard>
                                <RefSocialWrapper
                                    onClick={() => {
                                        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedInviteUrl}`);
                                    }}
                                >
                                    <div>
                                        <V3IconFacebook width="24" height="24" />
                                    </div>
                                    <div>
                                        <V3Body>Post on Facebook</V3Body>
                                    </div>
                                </RefSocialWrapper>
                            </RefDashboardBottomPanelCard>
                            <RefDashboardBottomPanelCard>
                                <RefSocialWrapper
                                    onClick={() => {
                                        window.open(
                                            `https://www.linkedin.com/shareArticle?mini=true&url=${encodedInviteUrl}&title=How%20to%20back%20up%20all%20your%20articles%20automatically&summary=I'm%20using%20Authory%20to%20back%20up%20all%20my%20articles%20automatically,%20turn%20my%20readers%20into%20email%20subscribers%20and%20have%20a%20portfolio%20page%20that%20is%20always%20up%20to%20date!%20Try%20it%20free%20&source=`
                                        );
                                    }}
                                >
                                    <div>
                                        <V3IconLinkedin width="24" height="24" />
                                    </div>
                                    <div>
                                        <V3Body>Post on LinkedIn</V3Body>
                                    </div>
                                </RefSocialWrapper>
                            </RefDashboardBottomPanelCard>
                            <RefDashboardBottomPanelCard>
                                <RefSocialWrapper
                                    onClick={() => {
                                        window.open(
                                            `https://twitter.com/intent/tweet?text=Trying%20out%20%40Authory!%20It%E2%80%99s%20a%20great%20platform%20helping%20content%20creators%20to%20manage%20all%20their%20articles%2C%20posts%2C%20videos%20and%20podcasts%20in%20a%20single%20place%20%E2%80%93%20no%20matter%20where%20and%20when%20they%20are%20published.%20Perfect%20for%20writers%2C%20journalists%2C%20content%20marketers%20and%20bloggers%3A%20${encodedInviteUrl}`
                                        );
                                    }}
                                >
                                    <div>
                                        <V3IconTwitter width="24" height="24" />
                                    </div>
                                    <div>
                                        <V3Body>Post on Twitter</V3Body>
                                    </div>
                                </RefSocialWrapper>
                            </RefDashboardBottomPanelCard>
                        </RefDashboardBottomPanel>
                    </RefDashboarPanel>
                    <VerticalSpacing top={74} bottom={24}>
                        <V3Title>Frequently asked questions</V3Title>
                    </VerticalSpacing>
                    <FAQPrivateArea
                        headerText="How can I promote my invite link?"
                        body={
                            <>
                                <VerticalSpacing bottom={8}>
                                    <V3BodyGrey35>You can use your invite link in many different ways, for example:</V3BodyGrey35>
                                </VerticalSpacing>
                                <VerticalSpacing bottom={8}>
                                    <V3BodyGrey35>- Write a blog post and link from there</V3BodyGrey35>
                                </VerticalSpacing>
                                <VerticalSpacing bottom={8}>
                                    <V3BodyGrey35>- Link from a “Resources” or “Business Tools” page on your website</V3BodyGrey35>
                                </VerticalSpacing>
                                <VerticalSpacing bottom={8}>
                                    <V3BodyGrey35>- Include the link in your email newsletter(s)</V3BodyGrey35>
                                </VerticalSpacing>
                                <VerticalSpacing bottom={8}>
                                    <V3BodyGrey35>- Share the link in your social media posts and stories and YouTube videos</V3BodyGrey35>
                                </VerticalSpacing>
                                <VerticalSpacing bottom={8}>
                                    <V3BodyGrey35>- ... anything else that comes to your mind!</V3BodyGrey35>
                                </VerticalSpacing>
                                <V3BodyGrey35>
                                    Remember: Anybody invited by you gets a 30 day free trial instead of the standard 14 days. That’s exclusive and
                                    makes your invite link stand out!
                                </V3BodyGrey35>
                            </>
                        }
                    />
                    <VerticalSpacing top={16}>
                        <FAQPrivateArea
                            headerText="How do I know if anybody signed up with my invite link?"
                            body={
                                <>
                                    <V3BodyGrey35>
                                        Once per month you’ll receive a report via email from us listing signups that came via your invite link. This
                                        report will also contain details regarding how many of your signups converted into paying customers. Each
                                        paying customer entitles you to a referral bonus of USD 30.
                                    </V3BodyGrey35>
                                </>
                            }
                        />
                    </VerticalSpacing>
                    <VerticalSpacing top={16}>
                        <FAQPrivateArea
                            headerText="How do I get paid?"
                            body={
                                <>
                                    <V3BodyGrey35>
                                        At the end of each month, your rewards are calculated and available for cash-out via PayPal.
                                    </V3BodyGrey35>
                                </>
                            }
                        />
                    </VerticalSpacing>
                    <VerticalSpacing top={16}>
                        <FAQPrivateArea
                            headerText="When do I get paid?"
                            body={
                                <>
                                    <V3BodyGrey35>
                                        Payments are verified and paid-out the month after your commission is earned. For example, any commissions
                                        earned in February will be available March 16th.
                                    </V3BodyGrey35>
                                </>
                            }
                        />
                    </VerticalSpacing>
                    <VerticalSpacing top={16}>
                        <FAQPrivateArea
                            headerText="Questions?"
                            body={
                                <>
                                    <V3BodyGrey35>
                                        Shoot us an email at{" "}
                                        <InlineLink href="mailto:hello@authory.com?subject=Authory Invite Program">hello@authory.com</InlineLink>
                                    </V3BodyGrey35>
                                </>
                            }
                        />
                    </VerticalSpacing>
                </V3ContentLargeWrapper>
            }
        />
    );
};
